/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CheckAzureVMNameExistsRequest {
  /**
  * The Azure account ID
  */
  'cloudAccountId': string;
  /**
  * The Azure resource group name
  */
  'resourceGroup': string;
  /**
  * The Azure VM name to check
  */
  'vmName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudAccountId",
      "baseName": "cloudAccountId",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "vmName",
      "baseName": "vmName",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return CheckAzureVMNameExistsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

